import { render } from "./records.vue?vue&type=template&id=ba4e5eb6"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"

import "./records.vue?vue&type=style&index=0&id=ba4e5eb6&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__